var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-fixed"},[_c('v-card',{staticClass:"pa-4"},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }